var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock1 = function SvgClock1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C1.795 8 0 6.205 0 4s1.795-4 4-4 4 1.795 4 4-1.795 4-4 4ZM4 .636A3.368 3.368 0 0 0 .636 4 3.368 3.368 0 0 0 4 7.364 3.368 3.368 0 0 0 7.364 4 3.368 3.368 0 0 0 4 .636Z",
    fill: "#AFAFAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.682 4.132V1.716h.636v2.151l1.434 1.427-.448.452-1.622-1.614Z",
    fill: "#AFAFAF"
  })));
};
export default SvgClock1;